import { createAction, createReducer } from '@reduxjs/toolkit';
import { combineReducers, type AnyAction } from 'redux';

import entityJurisdictionsReducer, {
  initialState as entityJurisdictionsInitialState,
} from './entityJurisdictions';
import permissionsReducer, { initialState as permissionsInitialState } from './permissions';
import rolesReducer, { initialState as rolesInitialState } from './roles';
import { type ManageUsersState } from './types';
import userReducer, { initialState as userInitialState } from './user';

export const initialState: ManageUsersState = {
  user: userInitialState,
  roles: rolesInitialState,
  permissions: permissionsInitialState,
  entityJurisdictions: entityJurisdictionsInitialState,
};

const combinedReducers = combineReducers({
  user: userReducer,
  roles: rolesReducer,
  permissions: permissionsReducer,
  entityJurisdictions: entityJurisdictionsReducer,
});

export const manageUsersReset = createAction('manageUsers/reset');

const manageUsersRootReducer = createReducer(initialState, builder => {
  builder.addCase(manageUsersReset.type, () => initialState).addDefaultCase(() => {});
});

export default (state = initialState, action: AnyAction) => {
  const newState = manageUsersRootReducer(state, action);
  return combinedReducers(newState, action);
};
